// @ts-expect-error @headlessui/react
import {Dialog, Transition} from '@headlessui/react';
import {Image} from '@shopify/hydrogen';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {Fragment, ReactNode} from 'react';
import iconClose from '../assets/icons/icon-close.svg';
import {Text} from './index';
import {DATA_TEST_IDS} from '~/lib/const';

export function Modal({
  title,
  classNameTitle,
  classNamePanel,
  classNameContent,
  children,
  isOpen,
  closeButtonSize = 'medium',
  hideVerticalMargin,
  onCloseModal,
}: {
  title?: string;
  classNameTitle?: string;
  classNamePanel?: string;
  classNameContent?: string;
  children: ReactNode;
  isOpen: boolean;
  closeButtonSize?: 'small' | 'medium';
  hideVerticalMargin?: boolean;
  onCloseModal: () => void;
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onCloseModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div
          data-testid={DATA_TEST_IDS.MODAL}
          className="fixed inset-0 overflow-y-auto"
        >
          <div
            className={clsx(
              'flex min-h-full items-center justify-center text-center',
              {
                'my-10': !hideVerticalMargin,
              },
            )}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={twMerge(
                  clsx(
                    'w-full transform overflow-hidden bg-white text-left align-middle transition-all',
                    classNamePanel,
                  ),
                )}
              >
                <div>
                  <div className="flex justify-end">
                    <button
                      data-testid={DATA_TEST_IDS.BUTTON('close-modal')}
                      type="button"
                      className={clsx(
                        'bg-gray-200 rounded-full flex justify-center items-center cursor-pointer outline-none',
                        closeButtonSize === 'small' ? 'w-8 h-8' : 'w-12 h-12',
                      )}
                      onClick={onCloseModal}
                    >
                      <Image
                        src={iconClose}
                        width={closeButtonSize === 'small' ? 12 : 17}
                        height={closeButtonSize === 'small' ? 12 : 17}
                        alt="Close modal"
                        loading="lazy"
                      />
                    </button>
                  </div>

                  {title && (
                    <Dialog.Title as="span" className="mt-5">
                      <Text as="h2" className={classNameTitle}>
                        {title}
                      </Text>
                    </Dialog.Title>
                  )}
                </div>
                <div className={twMerge('mt-5', classNameContent)}>
                  {children}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
